import { inject, makeStateKey, TransferState } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { TServiceResult } from "@shared/helper/t-service-result";
import { IClubMeetingModel } from "@app/pages/clubs/models/club-meeting-model";
import { of } from "rxjs";
import { LocalRepository } from "@shared/helper/local-repository";
import { ClubMeetingService } from "@app/pages/clubs/services/club-meeting.service";
import { switchMap } from "rxjs/operators";

export const STATE_KEY_MEETING = makeStateKey<TServiceResult<IClubMeetingModel>>("STATE_KEY_MEETING");

export const MeetingDetailResolver: ResolveFn<TServiceResult<IClubMeetingModel>> = (route, state) => {
    const _localRepository: LocalRepository = inject(LocalRepository);
    const serverState: TransferState = inject(TransferState);
    const meetingService: ClubMeetingService = inject(ClubMeetingService);
    if (!_localRepository.IsInBrowser) {
        return meetingService.getMeetingById(route.paramMap.get('id')!)
            .pipe(switchMap(res => {
                serverState.set(STATE_KEY_MEETING, res);
                return of(res);
            }));
    }

    return of(serverState.get(STATE_KEY_MEETING, TServiceResult.fromFailure<any>(null)));
}
